// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ElevatorGroupSupervisoryStatus } from './elevator-group-supervisory-status';


export class ElevatorGroupSupervisoryStatusMessage implements flatbuffers.IUnpackableObject<ElevatorGroupSupervisoryStatusMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ElevatorGroupSupervisoryStatusMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsElevatorGroupSupervisoryStatusMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorGroupSupervisoryStatusMessage):ElevatorGroupSupervisoryStatusMessage {
  return (obj || new ElevatorGroupSupervisoryStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsElevatorGroupSupervisoryStatusMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorGroupSupervisoryStatusMessage):ElevatorGroupSupervisoryStatusMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ElevatorGroupSupervisoryStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():ElevatorGroupSupervisoryStatus {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ElevatorGroupSupervisoryStatus.UpPeak;
}

static startElevatorGroupSupervisoryStatusMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:ElevatorGroupSupervisoryStatus) {
  builder.addFieldInt16(0, message, ElevatorGroupSupervisoryStatus.UpPeak);
}

static endElevatorGroupSupervisoryStatusMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createElevatorGroupSupervisoryStatusMessage(builder:flatbuffers.Builder, message:ElevatorGroupSupervisoryStatus):flatbuffers.Offset {
  ElevatorGroupSupervisoryStatusMessage.startElevatorGroupSupervisoryStatusMessage(builder);
  ElevatorGroupSupervisoryStatusMessage.addMessage(builder, message);
  return ElevatorGroupSupervisoryStatusMessage.endElevatorGroupSupervisoryStatusMessage(builder);
}

unpack(): ElevatorGroupSupervisoryStatusMessageT {
  return new ElevatorGroupSupervisoryStatusMessageT(
    this.message()
  );
}


unpackTo(_o: ElevatorGroupSupervisoryStatusMessageT): void {
  _o.message = this.message();
}
}

export class ElevatorGroupSupervisoryStatusMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: ElevatorGroupSupervisoryStatus = ElevatorGroupSupervisoryStatus.UpPeak
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return ElevatorGroupSupervisoryStatusMessage.createElevatorGroupSupervisoryStatusMessage(builder,
    this.message
  );
}
}
